export default __webpack_public_path__ + "static/char-20-anr-8a8ec31d7c75e761d9dc0a19abc431c5.gif";